import * as React from 'react';
import {
    Spinner, SpinnerType
} from 'office-ui-fabric-react';
import { IElementDictionary, ISharedJourneyItem, IRedirectCandidate, ERedirectCandidateType, PropertyHelper, EJourneyToolSearchType } from '../../helpers';

interface IProps {
    results: IElementDictionary | ISharedJourneyItem[] | any;
    awaitingResults: boolean;
    displaySharedJourneyItems?: boolean;
    journeyToolSearchType?: EJourneyToolSearchType;
    displayRedirectCandidateItems?: boolean;
    onResultClick: (key: string, item: any) => void;
}

export class SearchResultsGrid extends React.Component<IProps, any> {

    render() {

        let { results, awaitingResults, onResultClick, displaySharedJourneyItems, displayRedirectCandidateItems, journeyToolSearchType } = this.props;

        let options: JSX.Element[] = [];

        if (awaitingResults) {
            options = [
                <li key='awaiting-results'>
                    <Spinner className="shared-journey-results-loader left" type={SpinnerType.normal} label="Searching..." />
                </li>
            ];
        }
        else if (journeyToolSearchType && Array.isArray(results) && results.length) {

            options = results.map((r: any) => {

                let isEnabled: boolean = (journeyToolSearchType == EJourneyToolSearchType.Upgraded) ? r.isLatestVersion : !r.isLatestVersion;


                let blueLabelText = r.version ? r.version : "no version";
                if (journeyToolSearchType == EJourneyToolSearchType.NotUpgraded) {
                    blueLabelText = + r.isLatestVersion ? "Upgraded" : "Not upgraded"
                }

                if (r.existInProcessList) {
                    return (
                        <div className="block-config-create-item ms-Grid-col ms-u-sm3 block"
                            id={r.journeyId} key={r.journeyId} onMouseDown={() => onResultClick(r.journeyId, r)}>
                            <div className="ms-Grid-row block-config-create-icon" title={r.journeyName}>
                                <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i>
                            </div>
                            <div className="ms-Grid-row block-config-create-label journeyversion" title={r.journeyName}>In the list {r.journeyName}</div>
                        </div>
                        // <li className="journeyinlist" id={r.journeyId} key={r.journeyId} onMouseDown={() => onResultClick(r.journeyId, r)}>
                        // 	<span className="journeyversion">In the list</span>{r.journeyName}
                        // </li>
                    );
                }
                else if (!isEnabled) {
                    return (
                        <div className="block-config-create-item ms-Grid-col ms-u-sm3 block"
                            id={r.journeyId} key={r.journeyId} onMouseDown={() => onResultClick(null, r)}>
                            <div className="ms-Grid-row block-config-create-icon" title={r.journeyName}>
                                <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i>
                            </div>
                            <div className="ms-Grid-row block-config-create-label" title={r.journeyName}>{blueLabelText} {r.journeyName}</div>
                        </div>
                        // <li id={r.journeyId} className={"admintool-isdisabled"} key={r.journeyId} onMouseDown={() => onResultClick(null, r)}>
                        //     <span className="journeyversion">{blueLabelText}</span>{r.journeyName}
                        // </li>
                    );
                }
                else {
                    return (
                        <div className="block-config-create-item ms-Grid-col ms-u-sm3 block"
                            id={r.journeyId} key={r.journeyId} onMouseDown={() => onResultClick(r.journeyId, r)}>
                            <div className="ms-Grid-row block-config-create-icon" title={r.journeyName}>
                                <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i>
                            </div>
                            <div className="ms-Grid-row block-config-create-label" title={r.journeyName}>{blueLabelText} {r.journeyName}</div>

                        </div>
                        // <li className="journeynotinlist" id={r.journeyId} key={r.journeyId} onMouseDown={() => onResultClick(r.journeyId, r)}>
                        //     <span className="journeyversion">{blueLabelText}</span>{r.journeyName}
                        // </li>
                    );
                }
            });
        }
        else if (displaySharedJourneyItems && Array.isArray(results) && results.length) {

            options = results.map((r: ISharedJourneyItem) => {
                return (
                    <div className="block-config-create-item ms-Grid-col ms-u-sm3 block"
                        key={r.journeyId} onMouseDown={() => onResultClick(r.journeyId, r.journeyName)}>
                        <div className="ms-Grid-row block-config-create-icon" title={r.journeyName}>
                            <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i>
                        </div>
                        <div className="ms-Grid-row block-config-create-label journeyversion" title={r.journeyName}>{r.journeyName}</div>
                    </div>
                    // <li key={r.journeyId} onMouseDown={() => onResultClick(r.journeyId, r.journeyName)}>
                    //     {r.journeyName}
                    // </li>
                );
            });
        }
        else if (displayRedirectCandidateItems && Array.isArray(results) && results.length) {
            options = results.map((r: IRedirectCandidate) => {

                switch (r.Type) {
                    case ERedirectCandidateType.serviceType:

                        let key = JSON.parse(PropertyHelper.getPropertyValue(r.Properties, 'Service Type ID'));
                        let value = JSON.parse(PropertyHelper.getPropertyValue(r.Properties, 'Service Type Name'));
                        return (
                            <div className="block-config-create-item ms-Grid-col ms-u-sm3 block"
                                key={key.text} onMouseDown={() => onResultClick(key, r)}>
                                <div className="ms-Grid-row block-config-create-icon" title={value.text}>
                                    <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i>
                                </div>
                                <div className="ms-Grid-row block-config-create-label journeyversion" title={value.text}>{value.text}</div>
                            </div>
                            // <li key={key.text} onMouseDown={() => onResultClick(key, r)}>
                            //     {value.text}
                            // </li>
                        );

                    case ERedirectCandidateType.external:
                        let key2 = JSON.parse(PropertyHelper.getPropertyValue(r.Properties, 'External Url Address'));
                        let value2 = JSON.parse(PropertyHelper.getPropertyValue(r.Properties, 'External Url Name'));
                        return (
                            <div className="block-config-create-item ms-Grid-col ms-u-sm3 block"
                                key={key2.text} onMouseDown={() => onResultClick(key2, r)}>
                                <div className="ms-Grid-row block-config-create-icon" title={value2.text}>
                                    <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i>
                                </div>
                                <div className="ms-Grid-row block-config-create-label journeyversion" title={value2.text}>{value2.text}</div>
                            </div>

                            // <li key={key2.text} onMouseDown={() => onResultClick(key2, r)}>
                            //     {value2.text}
                            // </li>
                        );

                    default:
                        return null;
                }
            });
        }
        else if (Object.keys(results).length) {
            for (let key in results) {
                options.push(
                    <div className="block-config-create-item ms-Grid-col ms-u-sm3 block" key={key} onMouseDown={() => onResultClick(key, results[key])}>
                        <div className="ms-Grid-row block-config-create-icon" title={results[key].props.children[1]}>
                            {results[key].props.children[0]}
                            {/* <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i> */}
                        </div>
                        <div className="ms-Grid-row block-config-create-label journeyversion" title={results[key].props.children[1]}>{results[key].props.children[1]}</div>
                    </div>

                    // <li key={key} onMouseDown={() => onResultClick(key, results[key])}>
                    //     {results[key]}
                    // </li>
                );
            }
        }
        else {
            options = [
                <div key='no-matching-results'>
                    <div className="block-config-create ms-Grid">
                        <div className="block-config-create-container ms-Grid-row">
                            <div className="block-config-create-item ms-Grid-col ms-u-sm3 block">
                                <div className="ms-Grid-row block-config-create-icon" title={'No matching results'}>
                                    <i className="ms-Icon ms-Icon--AppIconDefault" aria-hidden="true"></i>
                                </div>
                                <div className="ms-Grid-row block-config-create-label journeyversion" title={'No matching results'}>No matching results</div>
                            </div>
                        </div>
                    </div>
                </div >


                // <li key='no-matching-results'>No matching results</li>
            ];
        }

        return (
            <div className="search-results-grid">
                <div className="block-config-create ms-Grid">
                    <div className="block-config-create-container ms-Grid-row">

                        {options}
                    </div>
                </div>

                {/* <ul className='search-results ms-font-m ms-u-slideDownIn20 anim-1'>
                    {options}

                </ul> */}
            </div>

        );

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/common/search-results-grid.tsx